import React, { Fragment } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Stack } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import VSNTypography from "../../shared/VSNTypography";
import VSNButton from "../../shared/VSNButton";
import { toggleModelShow } from "../../shared/CustomFunc";

const labelAndDetail = {
  organization_admin: {
    header: "ORGANIZATIONAL DETAILS",
    detail: [
      {
        label: "Organization Name",
        value: "name",
      },
      {
        label: "Organization ID",
        value: "id",
      },
      {
        label: "Organization Address",
        value: ["address_line_1", "address_line_2", "city", "zip_code"],
        xs: 6,
        lg: 4,
      },
    ],
  },
  location_admin: {
    header: "LOCATION DETAILS",
    detail: [
      {
        label: "Location Name",
        value: "name",
      },
      {
        label: "Location ID",
        value: "original_id",
      },
      {
        label: "Location Address",
        value: ["address_line_1", "address_line_2", "city", "zip_code"],
        xs: 6,
        lg: 4,
      },
    ],
  },
  department_admin: {
    header: "DEPARTMENT DETAILS",
    detail: [
      {
        label: "Department Name",
        value: "name",
      },
      {
        label: "Department ID",
        value: "id",
      },
      {
        label: "Department Type",
        value: "type_name",
      },
      {
        label: "Location",
        value: "location",
      },
      {
        label: "Department Address",
        value: ["address_line_1", "address_line_2", "city", "zip_code"],
        xs: 6,
        lg: 4,
      },
    ],
  },
};

const useStyles = makeStyles((theme) => ({
  label: {
    "&.MuiTypography-root": {
      fontSize: 14,
      color: "var(--gray)",
      fontWeight: 700,
      lineHeight: "18px",
      minHeight: 22,
    },
  },
  data: {
    "&.MuiTypography-root": {
      fontSize: 16,
      color: "var(--black)",
      fontWeight: 400,
      lineHeight: "20px",
      padding: "8px 0",
      wordBreak: "break-word",
    },
  },
  createButton: {
    "&.MuiButton-root": {
      padding: "11px 25px",
      "& svg": {
        height: 20,
      },
      "& .content": {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: "18px",
        display: "flex",
        alignItems: "center",
        gap: 8,
        [theme.breakpoints.down("md")]: {
          fontSize: 14,
        },
        "& .MuiStack-root": {
          gap: 10,
        },
      },
      [theme.breakpoints.down("md")]: {
        padding: "8px 12px",
      },
    },
  },
}));

const ShowDetail = ({ activeTab, findTab, UploadOrgWavier }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { permissions } =
    useSelector((state) => state?.app?.userData?.user_profile) ?? {};
  const summaryData = useSelector((state) => state?.api?.organizationSummary);

  return (
    <>
      {findTab?.showDetail &&
        permissions[findTab.showDetail] &&
        permissions[findTab.showDetail]?.includes("view") && (
          <Stack sx={{ maxWidth: 1200, width: "100%", mb: 5 }}>
            <VSNTypography
              variant="h4"
              color="#86650A"
              fontSize={14}
              fontWeight={700}
              mb={3.5}
            >
              {labelAndDetail?.[activeTab]?.header}
            </VSNTypography>
            <Grid container spacing={3.5}>
              {labelAndDetail?.[activeTab]?.detail?.map(
                ({ label, value, ...props }, index) => {
                  const getAddress = (values) => {
                    if (Array?.isArray(values)) {
                      const address = values
                        ?.map((key) => summaryData[key] || "")
                        ?.filter(Boolean)
                        ?.join(", ");
                      return address ? `${address}.` : "";
                    }
                    return "";
                  };

                  return (
                    <Fragment key={index}>
                      {summaryData?.[value] || Array.isArray(value) ? (
                        <Grid item xs={6} lg={2} {...props}>
                          <VSNTypography className={classes.label} variant="h5">
                            {label}
                          </VSNTypography>
                          <VSNTypography
                            className={classes.data}
                            sx={{ wordBreak: "break-word" }}
                          >
                            {Array.isArray(value)
                              ? getAddress(value)
                              : summaryData?.[value]}
                          </VSNTypography>
                        </Grid>
                      ) : null}
                    </Fragment>
                  );
                }
              )}
            </Grid>
          </Stack>
        )}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <VSNTypography
          variant="h4"
          color="#86650A"
          fontSize={14}
          fontWeight={700}
          mb={2}
        >
          {findTab?.tableName}
        </VSNTypography>

        {activeTab === "waivers" && (
          <VSNButton
            handleClick={() => dispatch(toggleModelShow("uploadDocumnet"))}
            className={classes.createButton}
          >
            <Stack direction="row" alignItems="center">
              <FileUploadOutlinedIcon />
            </Stack>
            Upload
          </VSNButton>
        )}
      </Stack>
    </>
  );
};

export default ShowDetail;
